import { type ODSIconProps } from '@telekom-ods/react-icons';
import { ODSInlineNotification, type ODSLinkProps } from '@telekom-ods/react-ui-kit';
import React, { type ReactElement } from 'react';

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  mode?: 'success' | 'error' | 'informative' | 'warning';
  title: string;
  text?: string;
  titleHeading?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  link1Props?: Omit<ODSLinkProps, 'variant'>;
  link2Props?: Omit<ODSLinkProps, 'variant'>;
  iconProps?: ODSIconProps;
  className?: string;
}

const Alert: React.FC<AlertProps> = ({
  mode = 'error',
  title,
  text,
  titleHeading = 'h3',
  link1Props,
  link2Props,
  iconProps,
  className = '',
  ...otherProps
}): ReactElement => {
  return (
    <ODSInlineNotification
      {...otherProps}
      className={className}
      mode={mode}
      title={title}
      {...(text && {
        text,
      })}
      titleHeading={titleHeading}
      opened
      showCloseButton={false}
      {...(link1Props && { link1Props: { ...link1Props } })}
      {...(link2Props && { link2Props: { ...link2Props } })}
      {...(iconProps && { iconProps: { ...iconProps } })}
    />
  );
};

export default Alert;
